export default __webpack_public_path__ + "static/media/dow.53dae836.jpeg";